<mat-horizontal-stepper [@.disabled]="true" [animationDuration]="'0'">
  @for (step of field.fieldGroup; track step; let index = $index; let last = $last) {
  <mat-step>
    <formly-field [field]="step"></formly-field>
  </mat-step>
  }
</mat-horizontal-stepper>

<div class="controls-wrapper">
  <ion-toolbar>
    <ion-grid>
      <ion-row>
        <ion-progress-bar [value]="progress"></ion-progress-bar>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-button tabIndex="1" expand="block" color="purple" fill="outline" (click)="prevStep()"
            [disabled]="formlyService.getStepperIndex() === 0">
            Previous
          </ion-button>
        </ion-col>
        <ion-col>
          <!-- <ion-button tabIndex="1" expand="block" color="purple" fill="solid" (click)="nextStep()">
            {{formlyService.getStepperIndex() === stepper?.steps?.length - 1 ? 'Done' : 'Next'}}
          </ion-button> -->
          <ion-button tabIndex="1" expand="block" color="purple" fill="solid" (click)="nextStep()"
            [disabled]=questionRequired>
            {{formlyService.getStepperIndex() === stepper?.steps?.length - 1 ? 'Done' : 'Next'}}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</div>